/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./size-filter.vue?vue&type=template&id=0cc212b0&"
import script from "./size-filter.vue?vue&type=script&lang=ts&"
export * from "./size-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports